import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        
          Horizons Shul
       
      </header>
    </div>
  );
}

export default App;
